module.exports = __webpack_public_path__ + "static/media/blue-arrow-up.8cb7dd6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/blue-arrow-up.svg
// module id = 852
// module chunks = 21